export enum InvoiceTaxRegime {
  NONE = 'NONE',
  SIMPLES_NATIONAL = 'SIMPLES_NATIONAL',
  SIMPLES_NATIONAL_EXCESS = 'SIMPLES_NATIONAL_EXCESS',
  NORMAL_PROFIT_ESTIMATE = 'NORMAL_PROFIT_ESTIMATE',
  NORMAL_REAL_PROFIT = 'NORMAL_REAL_PROFIT',
}

export enum InvoiceItemRelevanceScaleIndicator {
  PRODUCED_ON_A_RELEVANT_SCALE = 'PRODUCED_ON_A_RELEVANT_SCALE',
  PRODUCED_AT_NON_RELEVANT_SCALE = 'PRODUCED_AT_NON_RELEVANT_SCALE',
}

export enum InvoiceItemType {
  PART = 'PART',
  CONSUMABLE = 'CONSUMABLE',
  TASK = 'TASK',
}

export enum InvoiceType {
  NFE = 'NFE',
  NFC = 'NFC',
  NFS = 'NFS',
  CFE = 'CFE',
}

export enum InvoiceOriginReferenceEntity {
  WORK_ORDER = 'WORK_ORDER',
  SALES = 'SALES',
  PURCHASE = 'PURCHASE',
}

export enum InvoiceDocumentType {
  ENTRY = 'ENTRY',
  EXIT = 'EXIT',
}

export enum InvoiceEmissionGoal {
  NFE_NORMAL = 'NFE_NORMAL',
  NFE_ADDITIONAL = 'NFE_ADDITIONAL',
  NFE_ADJUSTMENT = 'NFE_ADJUSTMENT',
  NFE_MERCHANDISE_RETURN = 'NFE_MERCHANDISE_RETURN',
}

export enum InvoiceEmissionType {
  NORMAL_EMISSION = 'NORMAL_EMISSION',
  CONTINGENCY_FS_IA = 'CONTINGENCY_FS_IA',
  CONTINGENCY_SCAN = 'CONTINGENCY_SCAN',
  CONTINGENCY_DPEC = 'CONTINGENCY_DPEC',
  CONTINGENCY_FS_DA = 'CONTINGENCY_FS_DA',
  CONTINGENCY_SVC_AN = 'CONTINGENCY_SVC_AN',
  CONTINGENCY_SVC_RS = 'CONTINGENCY_SVC_RS',
}

export enum InvoiceOperationDestination {
  INTERNAL_OPERATION = 'INTERNAL_OPERATION',
  INTERSTATE_OPERATION = 'INTERSTATE_OPERATION',
  FOREIGN_OPERATION = 'FOREIGN_OPERATION',
}

export enum InvoiceRecipientType {
  CUSTOMER = 'CUSTOMER',
  SUPPLIER = 'SUPPLIER',
  INSURER = 'INSURER',
}

export enum InvoiceSpedStatusRegistered {
  PENDING = 'PENDING',
  ERROR = 'ERROR',
  INSERTED = 'INSERTED',
}

export const InvoiceSpedStatusRegisteredConstants: Record<
  InvoiceSpedStatusRegistered,
  { color: string; label: string }
> = {
  ERROR: { color: 'red', label: 'Erro' },
  INSERTED: { color: 'green', label: 'Inserido' },
  PENDING: { color: 'gray', label: 'Pendente' },
};

export enum InvoiceSituation {
  REPLACED = 'REPLACED',
  IN_TYPING = 'IN_TYPING',
  VALIDATED = 'VALIDATED',
  PROCESSING = 'PROCESSING',
  AUTHORIZED = 'AUTHORIZED',
  CANCELED = 'CANCELED',
  PROCESSING_CANCELLATION = 'PROCESSING_CANCELLATION',
  DENIED = 'DENIED',
  INTERRUPTED = 'INTERRUPTED',
}

export enum InvoiceProvider {
  FINTEL = 'FINTEL',
  SIAPPA = 'SIAPPA',
  DATAPUBLIC = 'DATAPUBLIC',
  CEBIUP = 'CEBIUP',
  GOIANIA = 'GOIANIA',
}

export enum InvoiceTaxationNature {
  SIMPLES_NACIONAL = 'SIMPLES_NACIONAL',
  FIXO = 'FIXO',
  DEPOSITO_EM_JUIZO = 'DEPOSITO_EM_JUIZO',
  EXIGIBILIDADE_SUSPENSA_DECISAO_JUDICIAL = 'EXIGIBILIDADE_SUSPENSA_DECISAO_JUDICIAL',
  EXIGIBILIDADE_SUSPENSA_PROCEDIMENTO_ADMINISTRATIVO = 'EXIGIBILIDADE_SUSPENSA_PROCEDIMENTO_ADMINISTRATIVO',
  ISENCAO_PARCIAL = 'ISENCAO_PARCIAL',
  SEM_NATUREZA_DEFINIDA = 'SEM_NATUREZA_DEFINIDA',
}

export enum InvoiceSpecialTaxRegime {
  NO_SPECIAL_TAX_REGIME = 'NO_SPECIAL_TAX_REGIME',
  MUNICIPAL_MICRO_ENTERPRISE = 'MUNICIPAL_MICRO_ENTERPRISE',
  ESTIMATED = 'ESTIMATED',
  PROFESSIONAL_SOCIETY = 'PROFESSIONAL_SOCIETY',
  COOPERATIVE = 'COOPERATIVE',
  INDIVIDUAL_MICROENTREPRENEUR_MEI = 'INDIVIDUAL_MICROENTREPRENEUR_MEI',
  SMALL_OR_MICROENTERPRISE_ME_EPP = 'SMALL_OR_MICROENTERPRISE_ME_EPP',
  REAL_PROFIT = 'REAL_PROFIT',
  PRESUMED_PROFIT = 'PRESUMED_PROFIT',
  NORMAL_TAXATION = 'NORMAL_TAXATION',
  NATIONAL_SIMPLES_WITH_EXCESS_OF_SUBLIMIT = 'NATIONAL_SIMPLES_WITH_EXCESS_OF_SUBLIMIT',
  LIMITED_LIABILITY_COMPANY = 'LIMITED_LIABILITY_COMPANY',
}

export enum InvoiceTaxpayerType {
  ICMS_TAXPAYER = 'ICMS_TAXPAYER',
  EXEMPT_TAXPAYER = 'EXEMPT_TAXPAYER',
  NON_CONTRIBUTOR = 'NON_CONTRIBUTOR',
}

export enum InvoiceTypeOfStreet {
  ALAMEDA = 'ALAMEDA',
  AVENIDA = 'AVENIDA',
  CHACARA = 'CHACARA',
  COLONIA = 'COLONIA',
  CONDOMINIO = 'CONDOMINIO',
  EQNP = 'EQNP',
  ESTANCIA = 'ESTANCIA',
  ESTRADA = 'ESTRADA',
  FAZENDA = 'FAZENDA',
  PRACA = 'PRACA',
  PROLONGAMENTO = 'PROLONGAMENTO',
  RODOVIA = 'RODOVIA',
  RUA = 'RUA',
  SITIO = 'SITIO',
  TRAVESSA = 'TRAVESSA',
  VICINAL = 'VICINAL',
}

export enum InvoiceShippingMode {
  EMITTER = 'EMITTER',
  RECIPIENT = 'RECIPIENT',
  THIRD_PARTY = 'THIRD_PARTY',
  SENDER_OWN_TRANSPORT = 'SENDER_OWN_TRANSPORT',
  RECIPIENT_OWN_TRANSPORT = 'RECIPIENT_OWN_TRANSPORT',
  NO_SHIPPING = 'NO_SHIPPING',
}

export enum InvoiceOperationType {
  SUPPLY_WITH_PAYMENT_LATER = 'SUPPLY_WITH_PAYMENT_LATER',
  RECEIPT_OF_PAYMENT_MADE = 'RECEIPT_OF_PAYMENT_MADE',
  SUPPLY_WITH_PAYMENT_MADE = 'SUPPLY_WITH_PAYMENT_MADE',
  RECEIPT_OF_LATER_PAYMENT = 'RECEIPT_OF_LATER_PAYMENT',
  CONCOMITANT_SUPPLY_RECEIPT_PAYMENT = 'CONCOMITANT_SUPPLY_RECEIPT_PAYMENT',
}

export const InvoiceOperationTypeLabel: Record<InvoiceOperationType, string> = {
  SUPPLY_WITH_PAYMENT_LATER: '1 - Fornecimento com pagamento posterior',
  RECEIPT_OF_PAYMENT_MADE: '2 - Recibo de pagamento realizado',
  SUPPLY_WITH_PAYMENT_MADE: '3 - Fornecimento após pagamento realizado',
  RECEIPT_OF_LATER_PAYMENT: '4 - Recibo de pagamento posterior',
  CONCOMITANT_SUPPLY_RECEIPT_PAYMENT:
    '5 - Recibo de fornecimento e pagamento concomitantes',
};
